module.exports = __webpack_public_path__ + "static/media/features-management.396f715b.png";